import * as yup from 'yup';
import { KpiPeriod } from '../data-models/company-financials.data-model';
import { RendererType } from '../data-models/field-definition';
import { FMT } from '../util/formatter-service';
import { StringFormatterId } from '../util/formatters/StringFormatters';

export function tearSheetPerformanceSummaryPrefsFields() {
  return {
    viewType: yup
      .string()
      .oneOf(['tile', 'table'])
      .required()
      .default('table')
      .formMeta({
        renderer: RendererType.singleSelect,
        rendererMeta: {
          values: ['tile', 'table'].map((v) => ({
            displayName: FMT.format(StringFormatterId.capitalizedString, v),
            value: v,
          })),
        },
        disableClearable: true,
      }),
    period: yup
      .string()
      .oneOf(Object.values(KpiPeriod))
      .default(KpiPeriod.quarter)
      .nullable()
      .formMeta({
        renderer: RendererType.singleSelect,
        rendererMeta: {
          values: Object.values(KpiPeriod).map((v) => ({
            displayName: v,
            value: v,
          })),
        },
        disableClearable: true,
      }),
    relativePeriodDistances: yup
      .array()
      .of(yup.number())
      .nullable()
      .when('viewType', {
        is: 'table',
        then: (schema) => schema.required().min(1).default([0]),
        otherwise: (schema) => schema.notRequired().default(undefined),
      })
      .formMeta({
        renderer: RendererType.multiSelect,
      }),
  };
}

export function tearSheetPerformanceSummaryPrefsSchema() {
  return yup.object(tearSheetPerformanceSummaryPrefsFields());
}
export type TearSheetsPerfSettingsPrefs = yup.InferType<
  ReturnType<typeof tearSheetPerformanceSummaryPrefsSchema>
>;
